<template>
    <nav>
        <!-- Hamburger menu button on mobile -->
        <div class="block sm:hidden">
            <button type="button"
                class="text-xl fa fa-bars text-gray-600 px-3 py-3 -mt-2 -mr-1"
                @click="showMobile"
            ></button>
        </div>

        <transition name="fade">
            <div v-if="show_mobile"
                class="sm:hidden flex flex-col items-center justify-center fixed z-100 inset-0 w-full h-full bg-black bg-opacity-85"
            >
                <!-- Close button -->
                <button type="button"
                    class="absolute top-0 right-0 text-2xl fa fa-times-circle text-gray-600 px-4 py-4"
                    @click="hideMobile"
                ></button>

                <language :dark="true" />

                <div class="flex items-center my-6">
                    <div v-if="user.avatar"
                        class="border border-gray-600 flex flex-shrink-0 items-center justify-center mr-4 overflow-hidden rounded-full h-10 w-10"
                    >
                        <img :src="user.avatar" class="w-full" />
                    </div>

                    <i v-else class="text-lg fas fa-user mr-3 text-gray-600"></i>

                    <span class="text-xl select-none text-gray-500">
                        {{ user.name }}
                    </span>
                </div>

                <ul class="space-y-4">
                    <li class="group cursor-pointer uppercase">
                        <a class="group-hover:text-blue-400 text-md tracking-widest block px-2 py-1 rounded-md select-none text-center"
                            :class="current == dashboard_route ? 'text-blue-400' : 'text-gray-400'"
                            :href="routes.dashboard"
                        >
                            {{ $t(dashboard_title) }}
                        </a>
                    </li>

                    <li class="group cursor-pointer uppercase">
                        <a class="text-gray-400 group-hover:text-blue-400 text-md tracking-widest block px-2 py-1 rounded-md select-none text-center"
                            :href="routes.logout"
                        >
                            {{ $t('Log Out') }}
                        </a>
                    </li>
                </ul>
            </div>
        </transition>

        <!-- Desktop menu -->
        <div class="hidden sm:flex flex items-center">
            <div class="mr-6">
                <language :dark="true" />
            </div>

            <ul class="flex mb-0 xs:mr-4">
                <li class="group cursor-pointer uppercase pr-2 xs:px-2">
                    <a class="group-hover:text-blue-400 text-xs sm:text-sm tracking-widest block px-2 py-1 rounded-md select-none"
                        :class="current == dashboard_route ? 'text-blue-400' : 'text-gray-400'"
                        :href="routes.dashboard"
                    >
                        {{ $t(dashboard_title) }}
                    </a>
                </li>

                <li class="group cursor-pointer uppercase xs:px-2">
                    <a class="text-gray-400 group-hover:text-blue-400 text-xs sm:text-sm tracking-widest block px-2 py-1 rounded-md select-none"
                        :href="routes.logout"
                    >
                        {{ $t('Log Out') }}
                    </a>
                </li>
            </ul>

            <div class="hidden md:flex items-center">
                <div v-if="user.avatar"
                    class="border border-gray-600 flex flex-shrink-0 items-center justify-center mr-4 overflow-hidden rounded-full h-10 w-10"
                >
                    <img :src="user.avatar" class="w-full" />
                </div>

                <i v-else class="text-lg fas fa-user mr-3 text-gray-600"></i>

                <span class="select-none text-gray-500">
                    {{ user.name }}
                </span>
            </div>
        </div>
    </nav>
</template>

<script>
import Language from './language.vue';

export default {
    components: {
        Language,
    },

    props: {
        user: {},
        routes: {},
        current: {},
        dashboard_title: {},
        dashboard_route: {},
    },

    data() {
        return {
            show_mobile: false,
        }
    },

    methods: {
        showMobile() {
            this.show_mobile = true;
        },
        hideMobile() {
            this.show_mobile = false;
        },
    },

    watch: {
        show_mobile(val) {
            if (val) {
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
            } else {
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        },
    },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
